import { EntityConstants } from '../../helpers/general.helper';
 
export const medicoConstants: EntityConstants = {
	apiEndpoint: 'api/medicos/',
	entityLabel: 'Medicos',
	entityLabelGender: 'M',
	navigateToParent: ''
}